$(document).ready(() => {
  const $filtersForm = $('#js-attachment-filters');

  if (!$filtersForm.length) {
    return;
  }

  $filtersForm.on('submit', () => {
    $filtersForm
      .find(':input')
      .each((idx, input) => {
        const $input = $(input);

        if ('' === $input.val()) {
          $input.prop('disabled', true);
        }
      });
  });

  $(document).on('change', '#js-attachment-filters select', () => {
    $filtersForm.submit();
  });

  const $dropdownFilters = $('.js-attachment-filter-dropdown');
  let optionsUpdated = false;

  $dropdownFilters.on('shown.bs.dropdown', () => {
    optionsUpdated = false;
  });
  $dropdownFilters.on('change', ':input', (e) => {
    optionsUpdated = true;
    $(e.currentTarget).closest('.js-attachment-filter-dropdown').hasClass('show') || $filtersForm.submit();
  });
  $dropdownFilters.on('hidden.bs.dropdown', () => optionsUpdated && $filtersForm.submit());

  $('.js-search-link').on('click', (e) => e.stopPropagation());

  const $bulkActionBtn = $('.js-download-attachments-btn');

  function toggleBulkActionButton(disabled = false) {
    $bulkActionBtn.prop('disabled', disabled);
  }

  $(document).on('change', '.js-attachments-select-all', (e) => {
    const isChecked = $(e.currentTarget).is(':checked');

    toggleBulkActionButton(!isChecked);
    $('.js-attachment-checkbox').prop('checked', isChecked);
  });

  $(document).on('change', '.js-attachment-checkbox', () => {
    toggleBulkActionButton(0 === $('.js-attachment-checkbox:checked').length);
  });
});
